import {inject} from '@angular/core';
import {TranslateService as RuntimeTranslateService} from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import {Session} from "../../../../../models/session.model";
import Swal from "sweetalert2";
import {Groupe} from "../../../../../models/groupe.model";
import {CatalogueService} from "../../../../../services/catalogue.service";
import {SessionService} from "../../../../../services/session.service";
import {UntypedFormArray, UntypedFormBuilder, UntypedFormControl} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {Catalogue} from "../../../../../models/catalogue.model";
import {ConfigService} from "../../../../../services/config.service";
import {ChapitreService} from "../../../../../services/chapitre.service";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {Chapitre} from "../../../../../models/chapitre.model";


@Component({
    selector: 'app-edit-catalogue-session',
    templateUrl: './edit-chapitre.component.html',
    styleUrls: ['./edit-chapitre.component.css'],
    standalone: false
})
export class EditChapitreComponent implements OnInit {
  private readonly runtimeTranslate = inject(RuntimeTranslateService);

  constructor(private sessionService: SessionService,
              private activatedRoute: ActivatedRoute,
              private configService: ConfigService,
              private formBuilder: UntypedFormBuilder,
              private router: Router,
              private chapitreService: ChapitreService,) { }

  catalogue_id: string;
  chapitre_id: string;
  //Initialisation
  Sessions: Session[] = [];
  allSessions: Session[] = [];
  Chapitre = new Chapitre();
  ChapitreOlder = new Chapitre();
  ChapitreOlderSession = [];
  public profile_id = parseInt(localStorage.getItem('profile_id'));

  //Forms
  FormSessions: any;
  FormSessionsArray: any;

  //Group formatting
  page = 1;
  order = 'session.name';
  reverse = false;
  vQuery: string;

  //create ChoiceScreen
  responseMessage : string;
  //Group formatting
  setOrder(value: string) {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }
    this.order = value;
  }


  ngOnInit() {
    //access
    this.configService.checkUSerAccessByProfile(this.profile_id);
    //FORMS
    this.FormSessions = this.formBuilder.group({
      session_id: this.formBuilder.array([])
    });
    this.FormSessionsArray = <UntypedFormArray>this.FormSessions.controls.session_id;

    this.catalogue_id = (this.activatedRoute.snapshot.url[3].path)
    this.chapitre_id = (this.activatedRoute.snapshot.url[5].path)
    this.AllSession()
    this.GetChapitre(this.chapitre_id)
  }

  GetChapitre(id){
    this.chapitreService.getChapitre(id)
      .subscribe(res => {
        this.Chapitre = res.chapitre;
        this.ChapitreOlder = res.chapitre;
        this.Chapitre.sessions_chapitres.forEach(session => {
          // @ts-ignore
          this.checkSession(session.id,true);
        });
        this.Chapitre.sessions_chapitres.forEach(id => {
          this.ChapitreOlderSession.push(id);
        });
      }, (err) => {
        console.log(err);
      });
  }

  //SESSIONS
  //Recover all sessions
  AllSession() {
    this.sessionService.getSessionByUser()
      .subscribe(res => {
        this.Sessions = res.sessions;
        this.allSessions = [ ...this.Sessions ]
      }, (err) => {
        console.log(err);
      });
  }

  //get term of the search
  session_title_value(event : any){
    let session_title;
    session_title = event.target.value;
    this.search_sessions(session_title);
  }


  //FORM
  check_value(session_id){
    let value_check = this.FormSessionsArray.value.includes(session_id);
    if(value_check){
      return true;
    }
    else{
      return false;
    }
  }

  checkSession(session_id, event : any){
    if(event) {
      this.FormSessionsArray.push(new UntypedFormControl(session_id));
    } else {
      let index = this.FormSessionsArray.controls.findIndex(x => x.value == session_id)
      this.FormSessionsArray.removeAt(index);
    }
  }

  //Functionality who permit to search session
  search_sessions(session_title){
    //when only research filter byt sessions name
    if(session_title == 'all'){
      this.Sessions = [ ...this.allSessions ];
    }
    else if(session_title && session_title.length > 0) {
      this.Sessions = this.allSessions.filter((Session) => Session.title.toLocaleLowerCase().includes(session_title.toLocaleLowerCase()));
    }
    else{
      this.Sessions = [ ...this.allSessions ];
    }
  }

  //UPDATE Catalogue
  updateChapitre(id) {
    //This is to rectify an issue, as sending the form with an invalid session would trigger an error.
    this.search_sessions('all');
    const areDataEqual = JSON.stringify(this.FormSessionsArray.value) === JSON.stringify(this.ChapitreOlder);
//filter sessions in new array in the good order
    let filteredSessions = this.Sessions.filter(session => {
      const id = session['id'];
      // Vérifier si l'ID est présent dans les contrôles du FormArray
      return this.FormSessionsArray.controls.some(control => control.value === id);
    });
    let NewSessionsAssociates = this.FormSessionsArray.controls.map(control => {
      const id = control.value;
      return filteredSessions.find(session => session['id'] === id);
    });
    // tslint:disable-next-line:max-line-length
    if (this.Chapitre.titre === undefined || this.Chapitre.titre.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.titleMissing')
      });
      return false;
      // tslint:disable-next-line:align
    }
    else if (this.Chapitre.description === undefined || this.Chapitre.description.trim() === '') {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.descriptionRequired'),
      });
      return false;
      // tslint:disable-next-line:align
    }
    else if (this.FormSessionsArray.length == 0) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.selectAtLeastTwoChoiceGroups'),
      });
      return false;
      // tslint:disable-next-line:align
    }
    else if (this.ChapitreOlder.titre == this.Chapitre.titre
      && this.ChapitreOlder.description == this.Chapitre.description
      && areDataEqual == true
    ) {
      Swal.fire({
        icon: 'error',
        title: this.runtimeTranslate.instant('alerts.oops'),
        text: this.runtimeTranslate.instant('messages.noChanges'),
      });
      return false;
    }
    else{
      const body = {
        titre: this.Chapitre.titre,
        description: this.Chapitre.description,
        array_chapitre_sessions : NewSessionsAssociates,
      };
      this.chapitreService.editChapitre(id,body)
        .subscribe(res => {
          if(res.status == false){
            Swal.fire({
              icon: 'error',
              title: this.runtimeTranslate.instant('alerts.oops'),
              text: res.message
            });
          }else{
            // @ts-ignore: Unreachable code error
          this.Chapitre.titre = '';
          this.Chapitre.description = '';
          Swal.fire({
            title: this.runtimeTranslate.instant('alerts.catalogUpdated'),
            text: res.message,
            icon: 'success',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.runtimeTranslate.instant('alerts.backToCatalogs'),
            cancelButtonText: this.runtimeTranslate.instant('alerts.stayOnPage')
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/dashboard/administrator/catalogue-management']);
            }
            else{
              window.location.reload();
            }
          });
          }}, (err) => {
          Swal.fire({
            icon: 'error',
            title: this.runtimeTranslate.instant('alerts.oops'),
          });
        });
    }
  }

//CARD DRAG AND DROP
  drop(event: CdkDragDrop<any>) {
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;

    const movedSession = this.FormSessionsArray.at(previousIndex);
    this.FormSessionsArray.removeAt(previousIndex);
    this.FormSessionsArray.insert(currentIndex, movedSession);
  }

  moveSessionUp(index: number) {
    if (index > 0) {
      const temp = this.FormSessionsArray[index];
      this.FormSessionsArray[index] = this.FormSessionsArray[index - 1];
      this.FormSessionsArray[index - 1] = temp;
    }
  }

  moveSessionDown(index: number) {
    if (index < this.FormSessionsArray.length - 1) {
      const temp = this.FormSessionsArray[index];
      this.FormSessionsArray[index] = this.FormSessionsArray[index + 1];
      this.FormSessionsArray[index + 1] = temp;
    }
  }
  toggleCollapse(session: any) {
    session.showDescription = !session.showDescription;
  }

  changeDuree(session_id,duree) {
    // Trouver l'index de la session dans l'array
    const sessionIndex = this.Sessions.findIndex(s => s.id === session_id);

    if (sessionIndex !== -1) {
      // Mettre à jour la session avec la nouvelle donnée d'événement
      this.Sessions[sessionIndex].duree = duree;
    } else {
      console.error('Session non trouvée dans FormSessionsArray');
    }
  }

  updateSessionDescription(newDescription: string, session: Session): void {
    const sessionIndex = this.Sessions.findIndex(s => s.id === session.id);
    if (sessionIndex !== -1) {
      this.Sessions[sessionIndex].description = newDescription;
    } else {
      console.error('Session not found in Sessions array');
    }
  }

  changeType(session_id, type: string){
    const sessionIndex = this.Sessions.findIndex(s => s.id === session_id);

    if (sessionIndex !== -1) {
      // Mettre à jour la session avec la nouvelle donnée d'événement
      this.Sessions[sessionIndex].type = type;
    } else {
      console.error('Session non trouvée dans FormSessionsArray');
    }
  }

}
